import { useRef } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import homeIllustration from "../assets/web_dev-animated.svg";
import { useGlobaleContext } from "../context";

const HomePage = () => {
  const btn = useRef();
  const { toggleHoverAnimation, MagneticBtn } = useGlobaleContext();

  const handleMouseMove = (e) => {
    MagneticBtn(e, btn);
  };

  return (
    <Wrapper>
      <section onMouseMove={handleMouseMove}>
        <h1 className="font-face-js section-heading">
          <span
            className="animated--letter "
            onMouseOver={toggleHoverAnimation}
          >
            H
          </span>
          <span
            className="animated--letter "
            onMouseOver={toggleHoverAnimation}
          >
            i
          </span>
          <span
            className="animated--letter "
            onMouseOver={toggleHoverAnimation}
          >
            &#44;
          </span>
          <br />
          <span
            className="animated--letter "
            onMouseOver={toggleHoverAnimation}
          >
            I
          </span>
          <span
            className="animated--letter "
            onMouseOver={toggleHoverAnimation}
          >
            &apos;
          </span>
          <span
            className="animated--letter "
            onMouseOver={toggleHoverAnimation}
          >
            m
          </span>
          &nbsp;
          <span
            className="animated--letter "
            onMouseOver={toggleHoverAnimation}
          >
            A
          </span>
          <span
            className="animated--letter "
            onMouseOver={toggleHoverAnimation}
          >
            b
          </span>
          <span
            className="animated--letter "
            onMouseOver={toggleHoverAnimation}
          >
            d
          </span>
          <span
            className="animated--letter "
            onMouseOver={toggleHoverAnimation}
          >
            e
          </span>
          <span
            className="animated--letter "
            onMouseOver={toggleHoverAnimation}
          >
            l
          </span>
          <span
            className="animated--letter "
            onMouseOver={toggleHoverAnimation}
          >
            g
          </span>
          <span
            className="animated--letter "
            onMouseOver={toggleHoverAnimation}
          >
            h
          </span>
          <span
            className="animated--letter "
            onMouseOver={toggleHoverAnimation}
          >
            a
          </span>
          <span
            className="animated--letter "
            onMouseOver={toggleHoverAnimation}
          >
            n
          </span>
          <span
            className="animated--letter "
            onMouseOver={toggleHoverAnimation}
          >
            i
          </span>
          <span
            className="animated--letter "
            onMouseOver={toggleHoverAnimation}
          >
            &#44;
          </span>
          <br />
          <span
            className="animated--letter "
            onMouseOver={toggleHoverAnimation}
          >
            W
          </span>
          <span
            className="animated--letter "
            onMouseOver={toggleHoverAnimation}
          >
            e
          </span>
          <span
            className="animated--letter "
            onMouseOver={toggleHoverAnimation}
          >
            b
          </span>
          &nbsp;
          <span
            className="animated--letter "
            onMouseOver={toggleHoverAnimation}
          >
            d
          </span>
          <span
            className="animated--letter "
            onMouseOver={toggleHoverAnimation}
          >
            e
          </span>
          <span
            className="animated--letter "
            onMouseOver={toggleHoverAnimation}
          >
            v
          </span>
          <span
            className="animated--letter "
            onMouseOver={toggleHoverAnimation}
          >
            e
          </span>
          <span
            className="animated--letter "
            onMouseOver={toggleHoverAnimation}
          >
            l
          </span>
          <span
            className="animated--letter "
            onMouseOver={toggleHoverAnimation}
          >
            o
          </span>
          <span
            className="animated--letter "
            onMouseOver={toggleHoverAnimation}
          >
            p
          </span>
          <span
            className="animated--letter "
            onMouseOver={toggleHoverAnimation}
          >
            e
          </span>
          <span
            className="animated--letter "
            onMouseOver={toggleHoverAnimation}
          >
            r
          </span>
        </h1>
        <Link ref={btn} className="btn" to="/contact" tabIndex="0">
          <span>L</span>et&apos;s talk
        </Link>
      </section>

      <img
        className="illustration"
        src={homeIllustration}
        alt="web delepoment Illustration"
      />
    </Wrapper>
  );
};
const Wrapper = styled.main`
  @media (max-width: 635px) {
    section {
      padding: 0 !important;
      align-items: center;
    }
    .illustration {
      height: 80vh !important;
      width: 80vw !important;
    }
  }
  section {
    padding-top: 2rem;
  }
  .section-heading {
    color: var(--colors-accent-700);
  }
  .animated--letter:hover {
    color: var(--colors-accent-300);
  }

  .btn {
    padding: 1.5rem;
    overflow: visible;
    width: max-content;
    color: var(--colors-accent-700);
  }
  .btn span {
    color: transparent;
    position: relative;
  }
  .btn span::before {
    content: "L";
    position: absolute;
    color: var(--colors-accent-700);
    transition: all 0.2s;
  }
  .btn::before {
    content: "";
    position: absolute;
    inset: 0;
    background-color: var(--colors-accent-300);
    z-index: -1;
    transition: var(--transition);
    opacity: 0;
  }
  .btn:hover {
    color: var(--colors-white);
    background-color: transparent !important;
  }
  @media (prefers-reduced-motion: no-preference) {
    .btn:hover span::before {
      color: var(--colors-white);
      font-size: 4.6rem;
      transform: translate(-60%, -43%) rotate(360deg);
    }
    .btn:hover::before {
      opacity: 1;
      transform: rotate(20deg);
    }
  }
  @media (prefers-reduced-motion: reduce) {
    .btn:hover {
      color: var(--colors-white) !important;

      background-color: var(--colors-accent-300) !important;
      & > span::before {
        color: var(--colors-white) !important;
      }
    }
  }

  @media (min-width: 1800px) {
    .section-heading {
      padding-top: 16rem;
      line-height: 11rem !important;
    }
  }
`;

export default HomePage;
